export default __webpack_public_path__ + "static/media/Freebooter's Straps of the Painted Claw.4e470955.jpg";